import type { CreatorSettings, ShareSettings, ViewerPanelMode } from '../types/project';

/**
 * Вид левой панели публичного вьювера.
 * Явная настройка шаринга побеждает; иначе проект с креатором получает карточки,
 * все существующие карты — прежнюю панель фильтров.
 */
export function resolveViewerPanelMode(
  settings: { creator?: CreatorSettings } | null | undefined,
  shareSettings: Pick<ShareSettings, 'panelMode'> | null | undefined,
): ViewerPanelMode {
  if (shareSettings?.panelMode) {
    return shareSettings.panelMode;
  }
  return settings?.creator ? 'cards' : 'filters';
}
